/* BubblePuff theme – vanilla JS, no dependencies */
(function () {
  'use strict';

  var T = window.theme || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || T.moneyFormat || '${{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var parts = (number / 100).toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelimiters(cents, 0);
        case 'amount_with_comma_separator': return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(cents, 0, '.', ',');
        default: return withDelimiters(cents, 2);
      }
    });
  }
  T.formatMoney = formatMoney;

  function toast(msg) {
    var el = $('#Toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Announcement bar ---------- */
  function initAnnouncement() {
    var bar = $('[data-announcement]');
    if (!bar) return;
    var items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    var i = 0;
    var speed = (parseInt(bar.getAttribute('data-speed'), 10) || 4) * 1000;
    setInterval(function () {
      var cur = items[i];
      i = (i + 1) % items.length;
      var next = items[i];
      cur.classList.remove('is-active');
      cur.classList.add('is-leaving');
      next.classList.remove('is-leaving');
      next.classList.add('is-active');
      setTimeout(function () { cur.classList.remove('is-leaving'); }, 500);
    }, speed);
  }

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    var menu = $('[data-mobile-menu]');
    var openBtn = $('[data-menu-open]');
    if (!menu || !openBtn) return;
    function close() { menu.hidden = true; openBtn.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; }
    openBtn.addEventListener('click', function () { menu.hidden = false; openBtn.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; });
    menu.addEventListener('click', function (e) {
      if (e.target === menu || e.target.closest('[data-menu-close]') || e.target.closest('a')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) close(); });
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var track = $('[data-gallery-track]', root);
    if (!track) return null;
    var slides = $$('.gallery__slide', track);
    var thumbs = $$('[data-thumb]', root);
    var dots = $$('.gallery__dot', root);
    var mobile = window.matchMedia('(max-width: 990px)');

    function setActive(index) {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    }
    function goTo(index) {
      if (index < 0 || index >= slides.length) return;
      setActive(index);
      if (mobile.matches) track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-thumb'), 10)); });
    });
    function current() {
      if (mobile.matches) return Math.round(track.scrollLeft / track.clientWidth);
      return Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    }
    var prevBtn = $('[data-gallery-prev]', root), nextBtn = $('[data-gallery-next]', root);
    if (prevBtn) prevBtn.addEventListener('click', function () { var i = current() - 1; goTo(i < 0 ? slides.length - 1 : i); });
    if (nextBtn) nextBtn.addEventListener('click', function () { var i = current() + 1; goTo(i >= slides.length ? 0 : i); });

    var raf;
    track.addEventListener('scroll', function () {
      if (!mobile.matches) return;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      });
    }, { passive: true });

    return {
      showMedia: function (mediaId) {
        if (!mediaId) return;
        var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
        if (idx > -1) goTo(idx);
      }
    };
  }

  /* ---------- Product forms ---------- */
  function initProductSection(section) {
    var gallery = initGallery(section);
    var wrapper = $('[data-product-form-wrapper]', section);
    if (!wrapper) return;
    var form = $('[data-product-form]', wrapper);
    var idInput = $('[data-variant-id]', wrapper);
    var atc = $('[data-add-to-cart]', wrapper);
    var atcLabel = $('[data-atc-label]', wrapper);
    var atcPrice = $('[data-atc-price]', wrapper);
    var priceBox = $('[data-price-box]', wrapper);
    var stickyPrice = $('[data-sticky-price]', section);
    var errorEl = $('[data-form-error]', wrapper);
    var isMainProduct = !!section.closest('.section-main-product');

    function renderPrice(price, compare) {
      if (!priceBox) return;
      var html = '<span class="price' + (compare > price ? ' price--sale' : '') + '"><span class="price__current">' + formatMoney(price) + '</span>';
      if (compare > price) {
        var save = Math.round((compare - price) * 100 / compare);
        html += '<s class="price__compare">' + formatMoney(compare) + '</s><span class="price__badge">Save ' + save + '%</span>';
      }
      priceBox.innerHTML = html + '</span>';
    }

    function selectVariant(input) {
      var price = parseInt(input.getAttribute('data-price'), 10);
      var compare = parseInt(input.getAttribute('data-compare'), 10) || 0;
      var available = input.getAttribute('data-available') === 'true';
      $$('.bundle', wrapper).forEach(function (b) { b.classList.remove('is-selected'); });
      input.closest('.bundle').classList.add('is-selected');
      if (idInput) idInput.value = input.value;
      renderPrice(price, compare);
      if (atcPrice) atcPrice.textContent = formatMoney(price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(price);
      if (atc) {
        atc.disabled = !available;
        if (atcLabel) atcLabel.textContent = available ? (atc.getAttribute('data-label') || atcLabel.textContent) : T.strings.soldOut;
      }
      if (gallery) gallery.showMedia(input.getAttribute('data-media'));
      if (isMainProduct && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        history.replaceState({}, '', url.toString());
      }
    }

    if (atc && atcLabel) atc.setAttribute('data-label', atcLabel.textContent);

    $$('[data-variant-input]', wrapper).forEach(function (input) {
      input.addEventListener('change', function () { if (input.checked) selectVariant(input); });
    });

    /* quantity bundle cards */
    var qtyHidden = $('[data-qty-hidden]', wrapper);
    var cards = $$('[data-card]', wrapper);
    function selectCard(card) {
      cards.forEach(function (c) { c.classList.toggle('is-selected', c === card); });
      var radio = $('[data-card-input]', card); if (radio) radio.checked = true;
      var price = parseInt(card.getAttribute('data-card-price'), 10);
      var compare = parseInt(card.getAttribute('data-card-compare'), 10) || 0;
      if (qtyHidden) qtyHidden.value = card.getAttribute('data-card-qty');
      renderPrice(price, compare);
      if (atcPrice) atcPrice.textContent = formatMoney(price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(price);
    }
    cards.forEach(function (card) {
      var radio = $('[data-card-input]', card);
      if (radio) radio.addEventListener('change', function () { if (radio.checked) selectCard(card); });
      card.addEventListener('click', function (e) {
        if (card.classList.contains('is-selected')) return;
        if (e.target.closest('select, .baddon')) return;
        selectCard(card);
      });
    });
    /* keep add-on checkboxes in sync across cards */
    wrapper.addEventListener('change', function (e) {
      var a = e.target.closest('[data-addon]');
      if (!a || !a.closest('[data-card]')) return;
      $$('[data-card] [data-addon][value="' + a.value + '"]', wrapper).forEach(function (o) { o.checked = a.checked; });
    });
    var initCard = $('[data-card].is-selected', wrapper) || cards[0];
    if (initCard) selectCard(initCard);

    /* add-on rows with their own "Add" button */
    $$('[data-quick-add]', wrapper).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var label = btn.textContent;
        btn.disabled = true;
        fetch(T.routes.cartAdd + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-quick-add'), 10), quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); btn.textContent = btn.getAttribute('data-added') || 'Added'; btn.classList.add('is-added'); if (T.cartDrawer === 'drawer') Cart.refresh(true); })
          .catch(function () { btn.textContent = label; })
          .finally(function () { btn.disabled = false; setTimeout(function () { btn.textContent = label; btn.classList.remove('is-added'); }, 2500); });
      });
    });

    /* quantity +/- (single-variant products) */
    $$('[data-qty]', wrapper).forEach(function (q) {
      var inp = $('input', q);
      $('[data-qty-minus]', q).addEventListener('click', function () { inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) - 1); });
      $('[data-qty-plus]', q).addEventListener('click', function () { inp.value = (parseInt(inp.value, 10) || 1) + 1; });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (errorEl) errorEl.hidden = true;
        var qtyInput = document.getElementById('Quantity-' + section.getAttribute('data-section-id'));
        var items = [];
        var selCard = $('[data-card].is-selected', wrapper);
        var unitSelects = selCard ? $$('[data-unit-select]', selCard) : [];
        if (unitSelects.length) {
          var counts = {};
          unitSelects.forEach(function (sel) { counts[sel.value] = (counts[sel.value] || 0) + 1; });
          Object.keys(counts).forEach(function (id) { items.push({ id: parseInt(id, 10), quantity: counts[id] }); });
        } else {
          items.push({ id: parseInt(idInput.value, 10), quantity: qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1 });
        }
        var addonScope = selCard && $('[data-addon]', selCard) ? $$('[data-addon]:checked', selCard) : $$('[data-addon]:checked', wrapper).filter(function (a) { return !a.closest('[data-card]'); });
        addonScope.forEach(function (a) { items.push({ id: parseInt(a.value, 10), quantity: 1 }); });

        var original = atcLabel ? atcLabel.textContent : '';
        if (atc) { atc.disabled = true; if (atcLabel) atcLabel.textContent = T.strings.adding; }

        fetch(T.routes.cartAdd + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to cart');
            if (T.cartDrawer === 'drawer') { Cart.refresh(true); }
            else { window.location.href = T.routes.cart; }
          })
          .catch(function (err) {
            if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          })
          .finally(function () {
            if (atc) { atc.disabled = false; if (atcLabel) atcLabel.textContent = original; }
          });
      });
    }

    /* sticky add to cart */
    var sticky = $('[data-sticky-atc]', section);
    if (sticky && atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
      io.observe(atc);
      var trigger = $('[data-sticky-trigger]', sticky);
      if (trigger) trigger.addEventListener('click', function () {
        var target = $('[data-bundles]', wrapper) || atc;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  /* ---------- Cart drawer ---------- */
  var Cart = {
    drawer: null,
    init: function () {
      this.drawer = $('[data-cart-drawer]');
      var self = this;
      document.addEventListener('click', function (e) {
        var openEl = e.target.closest('[data-cart-open]');
        if (openEl && self.drawer) { e.preventDefault(); self.refresh(true); return; }
        if (e.target.closest('[data-cart-close]')) { self.close(); return; }
        var change = e.target.closest('[data-line-change]');
        if (change) {
          var line = change.closest('[data-line]');
          self.change(line.getAttribute('data-key'), parseInt(change.getAttribute('data-line-change'), 10), line);
          return;
        }
        var add = e.target.closest('[data-cart-add]');
        if (add) { add.disabled = true; self.add([{ id: parseInt(add.getAttribute('data-cart-add'), 10), quantity: 1 }]).finally(function () { add.disabled = false; }); }
      });
      document.addEventListener('change', function (e) {
        var t = e.target.closest('[data-cart-protection-input]');
        if (!t) return;
        var id = parseInt(t.closest('[data-cart-protection]').getAttribute('data-variant'), 10);
        if (t.checked) { self.add([{ id: id, quantity: 1 }]); }
        else {
          var item = (self.cart && self.cart.items || []).find(function (i) { return i.variant_id === id; });
          if (item) self.change(item.key, 0);
        }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });
      if (this.drawer) this.refresh(false);
    },
    open: function () {
      if (!this.drawer) return;
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var closeBtn = $('.drawer__head [data-cart-close]', this.drawer);
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    },
    close: function () {
      if (!this.drawer || !this.drawer.classList.contains('is-open')) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },
    refresh: function (openAfter) {
      var self = this;
      return fetch(T.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); if (openAfter) self.open(); return cart; });
    },
    add: function (items) {
      var self = this;
      return fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json(); })
        .then(function () { return self.refresh(false); })
        .catch(function () { toast('Something went wrong'); });
    },
    change: function (key, quantity, lineEl) {
      var self = this;
      if (lineEl) lineEl.classList.add('is-loading');
      return fetch(T.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); })
        .catch(function () { if (lineEl) lineEl.classList.remove('is-loading'); toast('Something went wrong'); });
    },
    render: function (cart) {
      this.cart = cart;
      $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      if (!this.drawer) return;
      var d = this.drawer;
      var countText = $('[data-cart-count-text]', d);
      if (countText) countText.textContent = '(' + cart.item_count + ')';
      var body = $('[data-cart-items]', d);
      var foot = $('[data-cart-foot]', d);

      var protectEl = $('[data-cart-protection]', d);
      var protectId = protectEl ? parseInt(protectEl.getAttribute('data-variant'), 10) : null;
      var upsellEl = $('[data-cart-upsell]', d);
      var upsellId = upsellEl ? parseInt(upsellEl.getAttribute('data-variant'), 10) : null;
      var inCart = function (id) { return cart.items.some(function (i) { return i.variant_id === id; }); };

      /* free shipping bar (protection excluded) */
      var bar = $('[data-shipbar]', d);
      if (bar && T.freeShippingThreshold > 0) {
        var remaining = T.freeShippingThreshold - cart.total_price;
        var pct = Math.min(100, (cart.total_price / T.freeShippingThreshold) * 100);
        $('[data-shipbar-fill]', bar).style.width = pct + '%';
        $('[data-shipbar-text]', bar).textContent = remaining > 0
          ? T.strings.freeShippingAway.replace('[amount]', formatMoney(remaining))
          : T.strings.freeShippingUnlocked;
        bar.hidden = cart.item_count === 0;
      }

      var visibleItems = cart.items.filter(function (i) { return i.variant_id !== protectId; });
      if (visibleItems.length === 0) {
        var tpl = $('[data-cart-empty-template]', d);
        body.innerHTML = tpl ? tpl.innerHTML : '<p class="drawer__empty">' + escapeHtml(T.strings.empty) + '</p>';
        foot.hidden = true;
        if (upsellEl) upsellEl.hidden = true;
        return;
      }
      foot.hidden = false;
      if (upsellEl) upsellEl.hidden = inCart(upsellId);
      if (protectEl) $('[data-cart-protection-input]', protectEl).checked = inCart(protectId);

      $('[data-cart-subtotal]', d).textContent = formatMoney(cart.total_price);
      var tot = $('[data-cart-checkout-total]', d); if (tot) tot.textContent = formatMoney(cart.total_price);
      var saveRow = $('[data-cart-savings-row]', d);
      if (saveRow) {
        saveRow.hidden = !(cart.total_discount > 0);
        $('[data-cart-savings]', saveRow).textContent = '-' + formatMoney(cart.total_discount);
      }

      body.innerHTML = '<ul class="drawer__lines">' + visibleItems.map(function (item) {
        var img = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
        var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<p class="line__variant">' + escapeHtml(item.variant_title) + '</p>' : '';
        var discounts = (item.discounts || []).map(function (dc) { return '<p class="line__discount">' + escapeHtml(dc.title) + ' (−' + formatMoney(dc.amount) + ')</p>'; }).join('');
        var compare = item.original_line_price > item.final_line_price ? '<s class="line__compare">' + formatMoney(item.original_line_price) + '</s>' : '';
        return '<li class="line" data-line data-key="' + escapeHtml(item.key) + '">' +
          '<a href="' + escapeHtml(item.url) + '" class="line__media">' + (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(item.product_title) + '" width="72" height="72" loading="lazy">' : '') + '</a>' +
          '<div class="line__info"><a href="' + escapeHtml(item.url) + '" class="line__title">' + escapeHtml(item.product_title) + '</a>' + variant + discounts +
            '<div class="qty"><button type="button" class="qty__btn" data-line-change="' + (item.quantity - 1) + '" aria-label="Decrease">−</button>' +
            '<span class="qty__input" style="display:grid;place-items:center">' + item.quantity + '</span>' +
            '<button type="button" class="qty__btn" data-line-change="' + (item.quantity + 1) + '" aria-label="Increase">+</button></div></div>' +
          '<div class="line__end"><button type="button" class="line__remove" data-line-change="0" aria-label="' + escapeHtml(T.strings.remove) + '"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg></button>' +
            '<strong>' + formatMoney(item.final_line_price) + '</strong>' + compare + '</div>' +
        '</li>';
      }).join('') + '</ul>';
    }
  };
  window.BubbleCart = Cart;

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    var els = $$('.section-head, .step, .iwt__media, .iwt__content, .compare__table, .review, .accordion--faq, .cta__inner');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { el.classList.add('reveal'); io.observe(el); });
  }

  /* ---------- Review highlights slider ---------- */
  function initReviewHighlights(ctx) {
    $$('[data-rh-track]', ctx).forEach(function (track) {
      var root = track.closest('.section');
      var step = function () { var c = $('.rh__card', track); return c ? c.offsetWidth + 16 : 300; };
      var prev = $('[data-rh-prev]', root), next = $('[data-rh-next]', root);
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  /* ---------- Review widget: sort + load more ---------- */
  function initReviewWidget(ctx) {
    $$('[data-rw-list]', ctx).forEach(function (list) {
      var root = list.closest('.section');
      var size = parseInt(list.getAttribute('data-page-size'), 10) || 5;
      var shown = size;
      var items = $$('.rw__item', list);
      var moreWrap = $('[data-rw-more-wrap]', root);
      var moreBtn = $('[data-rw-more]', root);
      var sortSel = $('[data-rw-sort]', root);
      var filter = 'all';

      function apply() {
        var visible = items.filter(function (i) { return filter === 'all' || i.getAttribute('data-photo') === '1'; });
        items.forEach(function (i) { i.hidden = true; });
        visible.forEach(function (i, n) { i.hidden = n >= shown; });
        if (moreWrap) moreWrap.hidden = visible.length <= shown;
      }
      function sort(mode) {
        filter = mode === 'photos' ? 'photos' : 'all';
        items.sort(function (a, b) {
          var ra = +a.getAttribute('data-rating'), rb = +b.getAttribute('data-rating');
          var ia = +a.getAttribute('data-index'), ib = +b.getAttribute('data-index');
          if (mode === 'highest') return rb - ra || ia - ib;
          if (mode === 'lowest') return ra - rb || ia - ib;
          return ia - ib;
        });
        items.forEach(function (i) { list.appendChild(i); });
        shown = size; apply();
      }
      if (sortSel) sortSel.addEventListener('change', function () { sort(sortSel.value); });
      if (moreBtn) moreBtn.addEventListener('click', function () { shown += size; apply(); });
      apply();
    });
  }

  /* ---------- Theme editor support ---------- */
  function initAll(ctx) {
    $$('[data-product-section]', ctx).forEach(initProductSection);
    initReviewHighlights(ctx);
    initReviewWidget(ctx);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncement();
    initMenu();
    initAll(document);
    Cart.init();
    if (!window.Shopify || !Shopify.designMode) initReveal();
  });

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
